export const countryWithDialCode =  () =>{
    return [
        {
            "country_name": "Afghanistan",
            "country_dial_code": "+93",
            "country_code": "af"
        },
        {
            "country_name": "Albania",
            "country_dial_code": "+355",
            "country_code": "al"
        },
        {
            "country_name": "Algeria",
            "country_dial_code": "+213",
            "country_code": "dz"
        },
        {
            "country_name": "American Samoa",
            "country_dial_code": "+1684",
            "country_code": "as"
        },
        {
            "country_name": "Andorra",
            "country_dial_code": "+376",
            "country_code": "ad"
        },
        {
            "country_name": "Angola",
            "country_dial_code": "+244",
            "country_code": "ao"
        },
        {
            "country_name": "Anguilla",
            "country_dial_code": "+1264",
            "country_code": "ai"
        },
        {
            "country_name": "Antigua and Barbuda",
            "country_dial_code": "+1268",
            "country_code": "ag"
        },
        {
            "country_name": "Argentina",
            "country_dial_code": "+54",
            "country_code": "ar"
        },
        {
            "country_name": "Armenia",
            "country_dial_code": "+374",
            "country_code": "am"
        },
        {
            "country_name": "Aruba",
            "country_dial_code": "+297",
            "country_code": "aw"
        },
        {
            "country_name": "Australia",
            "country_dial_code": "+61",
            "country_code": "au"
        },
        {
            "country_name": "Austria",
            "country_dial_code": "+43",
            "country_code": "at"
        },
        {
            "country_name": "Azerbaijan",
            "country_dial_code": "+994",
            "country_code": "az"
        },
        {
            "country_name": "Bahamas",
            "country_dial_code": "+1242",
            "country_code": "bs"
        },
        {
            "country_name": "Bahrain",
            "country_dial_code": "+973",
            "country_code": "bh"
        },
        {
            "country_name": "Bangladesh",
            "country_dial_code": "+880",
            "country_code": "bd"
        },
        {
            "country_name": "Barbados",
            "country_dial_code": "+1246",
            "country_code": "bb"
        },
        {
            "country_name": "Belarus",
            "country_dial_code": "+375",
            "country_code": "by"
        },
        {
            "country_name": "Belgium",
            "country_dial_code": "+32",
            "country_code": "be"
        },
        {
            "country_name": "Belize",
            "country_dial_code": "+501",
            "country_code": "bz"
        },
        {
            "country_name": "Benin",
            "country_dial_code": "+229",
            "country_code": "bj"
        },
        {
            "country_name": "Bermuda",
            "country_dial_code": "+1441",
            "country_code": "bm"
        },
        {
            "country_name": "Bhutan",
            "country_dial_code": "+975",
            "country_code": "bt"
        },
        {
            "country_name": "Bolivia",
            "country_dial_code": "+591",
            "country_code": "bo"
        },
        {
            "country_name": "United States",
            "country_dial_code": "+1",
            "country_code": "us"
        },
        {
            "country_name": "Bosnia and Herzegovina",
            "country_dial_code": "+387",
            "country_code": "ba"
        },
        {
            "country_name": "Botswana",
            "country_dial_code": "+267",
            "country_code": "bw"
        },
        {
            "country_name": "Brazil",
            "country_dial_code": "+55",
            "country_code": "br"
        },
        {
            "country_name": "British Virgin Islands",
            "country_dial_code": "+1284",
            "country_code": "vg"
        },
        {
            "country_name": "Brunei",
            "country_dial_code": "+673",
            "country_code": "bn"
        },
        {
            "country_name": "Bulgaria",
            "country_dial_code": "+359",
            "country_code": "bg"
        },
        {
            "country_name": "Burkina Faso",
            "country_dial_code": "+226",
            "country_code": "bf"
        },
        {
            "country_name": "Burundi",
            "country_dial_code": "+257",
            "country_code": "bi"
        },
        {
            "country_name": "Cambodia",
            "country_dial_code": "+855",
            "country_code": "kh"
        },
        {
            "country_name": "Cameroon",
            "country_dial_code": "+237",
            "country_code": "cm"
        },
        {
            "country_name": "Canada",
            "country_dial_code": "+1",
            "country_code": "ca"
        },
        {
            "country_name": "Cape Verde",
            "country_dial_code": "+238",
            "country_code": "cv"
        },
        {
            "country_name": "Cayman Islands",
            "country_dial_code": "+1345",
            "country_code": "ky"
        },
        {
            "country_name": "Central African Republic",
            "country_dial_code": "+236",
            "country_code": "cf"
        },
        {
            "country_name": "Chad",
            "country_dial_code": "+235",
            "country_code": "td"
        },
        {
            "country_name": "Chile",
            "country_dial_code": "+56",
            "country_code": "cl"
        },
        {
            "country_name": "China",
            "country_dial_code": "+86",
            "country_code": "cn"
        },
        {
            "country_name": "Colombia",
            "country_dial_code": "+57",
            "country_code": "co"
        },
        {
            "country_name": "Comoros",
            "country_dial_code": "+269",
            "country_code": "km"
        },
        {
            "country_name": "Congo",
            "country_dial_code": "+243",
            "country_code": "cd"
        },
        {
            "country_name": "Congo brazzaville",
            "country_dial_code": "+242",
            "country_code": "cg"
        },
        {
            "country_name": "Cook Islands",
            "country_dial_code": "+682",
            "country_code": "ck"
        },
        {
            "country_name": "Costa Rica",
            "country_dial_code": "+506",
            "country_code": "cr"
        },
        {
            "country_name": "Ivory Coast",
            "country_dial_code": "+225",
            "country_code": "ci"
        },
        {
            "country_name": "Croatia",
            "country_dial_code": "+385",
            "country_code": "hr"
        },
        {
            "country_name": "Cuba",
            "country_dial_code": "+53",
            "country_code": "cu"
        },
        {
            "country_name": "Cyprus",
            "country_dial_code": "+357",
            "country_code": "cy"
        },
        {
            "country_name": "Czech Republic",
            "country_dial_code": "+420",
            "country_code": "cz"
        },
        {
            "country_name": "Denmark",
            "country_dial_code": "+45",
            "country_code": "dk"
        },
        {
            "country_name": "Djibouti",
            "country_dial_code": "+253",
            "country_code": "dj"
        },
        {
            "country_name": "Dominica",
            "country_dial_code": "+1767",
            "country_code": "dm"
        },
        {
            "country_name": "Dominican Republic",
            "country_dial_code": "+1",
            "country_code": "do"
        },
        {
            "country_name": "Ecuador",
            "country_dial_code": "+593",
            "country_code": "ec"
        },
        {
            "country_name": "Egypt",
            "country_dial_code": "+20",
            "country_code": "eg"
        },
        {
            "country_name": "El Salvador",
            "country_dial_code": "+503",
            "country_code": "sv"
        },
        {
            "country_name": "Equatorial Guinea",
            "country_dial_code": "+240",
            "country_code": "gq"
        },
        {
            "country_name": "Eritrea",
            "country_dial_code": "+291",
            "country_code": "er"
        },
        {
            "country_name": "Estonia",
            "country_dial_code": "+372",
            "country_code": "ee"
        },
        {
            "country_name": "Ethiopia",
            "country_dial_code": "+251",
            "country_code": "et"
        },
        {
            "country_name": "Falkland Islands",
            "country_dial_code": "+500",
            "country_code": "fk"
        },
        {
            "country_name": "Fiji",
            "country_dial_code": "+679",
            "country_code": "fj"
        },
        {
            "country_name": "Finland",
            "country_dial_code": "+358",
            "country_code": "fi"
        },
        {
            "country_name": "France",
            "country_dial_code": "+33",
            "country_code": "fr"
        },
        {
            "country_name": "French Guiana",
            "country_dial_code": "+594",
            "country_code": "gf"
        },
        {
            "country_name": "French Polynesia",
            "country_dial_code": "+689",
            "country_code": "pf"
        },
        {
            "country_name": "Gabon",
            "country_dial_code": "+241",
            "country_code": "ga"
        },
        {
            "country_name": "Gambia",
            "country_dial_code": "+220",
            "country_code": "gm"
        },
        {
            "country_name": "Georgia",
            "country_dial_code": "+995",
            "country_code": "ge"
        },
        {
            "country_name": "Germany",
            "country_dial_code": "+49",
            "country_code": "de"
        },
        {
            "country_name": "Ghana",
            "country_dial_code": "+233",
            "country_code": "gh"
        },
        {
            "country_name": "Gibraltar",
            "country_dial_code": "+350",
            "country_code": "gi"
        },
        {
            "country_name": "Greece",
            "country_dial_code": "+30",
            "country_code": "gr"
        },
        {
            "country_name": "Greenland",
            "country_dial_code": "+299",
            "country_code": "gl"
        },
        {
            "country_name": "Grenada",
            "country_dial_code": "+1473",
            "country_code": "gd"
        },
        {
            "country_name": "Guam",
            "country_dial_code": "+1671",
            "country_code": "gu"
        },
        {
            "country_name": "Guatemala",
            "country_dial_code": "+502",
            "country_code": "gt"
        },
        {
            "country_name": "Guinea",
            "country_dial_code": "+224",
            "country_code": "gn"
        },
        {
            "country_name": "Guinea-Bissau",
            "country_dial_code": "+245",
            "country_code": "gw"
        },
        {
            "country_name": "Guyana",
            "country_dial_code": "+592",
            "country_code": "gy"
        },
        {
            "country_name": "Haiti",
            "country_dial_code": "+509",
            "country_code": "ht"
        },
        {
            "country_name": "Honduras",
            "country_dial_code": "+504",
            "country_code": "hn"
        },
        {
            "country_name": "Hong Kong",
            "country_dial_code": "+852",
            "country_code": "hk"
        },
        {
            "country_name": "Hungary",
            "country_dial_code": "+36",
            "country_code": "hu"
        },
        {
            "country_name": "Iceland",
            "country_dial_code": "+354",
            "country_code": "is"
        },
        {
            "country_name": "India",
            "country_dial_code": "+91",
            "country_code": "in"
        },
        {
            "country_name": "Indonesia",
            "country_dial_code": "+62",
            "country_code": "id"
        },
        {
            "country_name": "Iran",
            "country_dial_code": "+98",
            "country_code": "ir"
        },
        {
            "country_name": "Iraq",
            "country_dial_code": "+964",
            "country_code": "iq"
        },
        {
            "country_name": "Ireland",
            "country_dial_code": "+353",
            "country_code": "ie"
        },
        {
            "country_name": "Israel",
            "country_dial_code": "+972",
            "country_code": "il"
        },
        {
            "country_name": "Italy",
            "country_dial_code": "+39",
            "country_code": "it"
        },
        {
            "country_name": "Jamaica",
            "country_dial_code": "+1876",
            "country_code": "jm"
        },
        {
            "country_name": "Japan",
            "country_dial_code": "+81",
            "country_code": "jp"
        },
        {
            "country_name": "Jordan",
            "country_dial_code": "+962",
            "country_code": "jo"
        },
        {
            "country_name": "Kazakhstan",
            "country_dial_code": "+7",
            "country_code": "kz"
        },
        {
            "country_name": "Kenya",
            "country_dial_code": "+254",
            "country_code": "ke"
        },
        {
            "country_name": "Kiribati",
            "country_dial_code": "+686",
            "country_code": "ki"
        },
        {
            "country_name": "Kuwait",
            "country_dial_code": "+965",
            "country_code": "kw"
        },
        {
            "country_name": "Kyrgyzstan",
            "country_dial_code": "+996",
            "country_code": "kg"
        },
        {
            "country_name": "Laos",
            "country_dial_code": "+856",
            "country_code": "la"
        },
        {
            "country_name": "Latvia",
            "country_dial_code": "+371",
            "country_code": "lv"
        },
        {
            "country_name": "Lebanon",
            "country_dial_code": "+961",
            "country_code": "lb"
        },
        {
            "country_name": "Lesotho",
            "country_dial_code": "+266",
            "country_code": "ls"
        },
        {
            "country_name": "Liberia",
            "country_dial_code": "+231",
            "country_code": "lr"
        },
        {
            "country_name": "Libya",
            "country_dial_code": "+218",
            "country_code": "ly"
        },
        {
            "country_name": "Liechtenstein",
            "country_dial_code": "+423",
            "country_code": "li"
        },
        {
            "country_name": "Lithuania",
            "country_dial_code": "+370",
            "country_code": "lt"
        },
        {
            "country_name": "Luxembourg",
            "country_dial_code": "+352",
            "country_code": "lu"
        },
        {
            "country_name": "Macau",
            "country_dial_code": "+853",
            "country_code": "mo"
        },
        {
            "country_name": "Macedonia",
            "country_dial_code": "+389",
            "country_code": "mk"
        },
        {
            "country_name": "Madagascar",
            "country_dial_code": "+261",
            "country_code": "mg"
        },
        {
            "country_name": "Malawi",
            "country_dial_code": "+265",
            "country_code": "mw"
        },
        {
            "country_name": "Malaysia",
            "country_dial_code": "+60",
            "country_code": "my"
        },
        {
            "country_name": "Maldives",
            "country_dial_code": "+960",
            "country_code": "mv"
        },
        {
            "country_name": "Mali",
            "country_dial_code": "+223",
            "country_code": "ml"
        },
        {
            "country_name": "Malta",
            "country_dial_code": "+356",
            "country_code": "mt"
        },
        {
            "country_name": "Marshall Islands",
            "country_dial_code": "+692",
            "country_code": "mh"
        },
        {
            "country_name": "Mauritania",
            "country_dial_code": "+222",
            "country_code": "mr"
        },
        {
            "country_name": "Mauritius",
            "country_dial_code": "+230",
            "country_code": "mu"
        },
        {
            "country_name": "Mexico",
            "country_dial_code": "+52",
            "country_code": "mx"
        },
        {
            "country_name": "Micronesia",
            "country_dial_code": "+691",
            "country_code": "fm"
        },
        {
            "country_name": "Moldova",
            "country_dial_code": "+373",
            "country_code": "md"
        },
        {
            "country_name": "Monaco",
            "country_dial_code": "+377",
            "country_code": "mc"
        },
        {
            "country_name": "Mongolia",
            "country_dial_code": "+976",
            "country_code": "mn"
        },
        {
            "country_name": "Montenegro",
            "country_dial_code": "+382",
            "country_code": "me"
        },
        {
            "country_name": "Montserrat",
            "country_dial_code": "+1664",
            "country_code": "ms"
        },
        {
            "country_name": "Morocco",
            "country_dial_code": "+212",
            "country_code": "ma"
        },
        {
            "country_name": "Mozambique",
            "country_dial_code": "+258",
            "country_code": "mz"
        },
        {
            "country_name": "Myanmar",
            "country_dial_code": "+95",
            "country_code": "mm"
        },
        {
            "country_name": "Namibia",
            "country_dial_code": "+264",
            "country_code": "na"
        },
        {
            "country_name": "Nauru",
            "country_dial_code": "+674",
            "country_code": "nr"
        },
        {
            "country_name": "Nepal",
            "country_dial_code": "+977",
            "country_code": "np"
        },
        {
            "country_name": "Netherlands",
            "country_dial_code": "+31",
            "country_code": "nl"
        },
        {
            "country_name": "New Caledonia",
            "country_dial_code": "+687",
            "country_code": "nc"
        },
        {
            "country_name": "New Zealand",
            "country_dial_code": "+64",
            "country_code": "nz"
        },
        {
            "country_name": "Nicaragua",
            "country_dial_code": "+505",
            "country_code": "ni"
        },
        {
            "country_name": "Niger",
            "country_dial_code": "+227",
            "country_code": "ne"
        },
        {
            "country_name": "Nigeria",
            "country_dial_code": "+234",
            "country_code": "ng"
        },
        {
            "country_name": "Niue",
            "country_dial_code": "+683",
            "country_code": "nu"
        },
        {
            "country_name": "Norfolk Island",
            "country_dial_code": "+672",
            "country_code": "nf"
        },
        {
            "country_name": "North Korea",
            "country_dial_code": "+850",
            "country_code": "kp"
        },
        {
            "country_name": "Northern Mariana Islands",
            "country_dial_code": "+1670",
            "country_code": "mp"
        },
        {
            "country_name": "Norway",
            "country_dial_code": "+47",
            "country_code": "no"
        },
        {
            "country_name": "Oman",
            "country_dial_code": "+968",
            "country_code": "om"
        },
        {
            "country_name": "Pakistan",
            "country_dial_code": "+92",
            "country_code": "pk"
        },
        {
            "country_name": "Palau",
            "country_dial_code": "+680",
            "country_code": "pw"
        },
        {
            "country_name": "Palestine",
            "country_dial_code": "+970",
            "country_code": "ps"
        },
        {
            "country_name": "Panama",
            "country_dial_code": "+507",
            "country_code": "pa"
        },
        {
            "country_name": "Papua New Guinea",
            "country_dial_code": "+675",
            "country_code": "pg"
        },
        {
            "country_name": "Paraguay",
            "country_dial_code": "+595",
            "country_code": "py"
        },
        {
            "country_name": "Peru",
            "country_dial_code": "+51",
            "country_code": "pe"
        },
        {
            "country_name": "Philippines",
            "country_dial_code": "+63",
            "country_code": "ph"
        },
        {
            "country_name": "Poland",
            "country_dial_code": "+48",
            "country_code": "pl"
        },
        {
            "country_name": "Portugal",
            "country_dial_code": "+351",
            "country_code": "pt"
        },
        {
            "country_name": "Puerto Rico",
            "country_dial_code": "+1",
            "country_code": "pr"
        },
        {
            "country_name": "Qatar",
            "country_dial_code": "+974",
            "country_code": "qa"
        },
        {
            "country_name": "Romania",
            "country_dial_code": "+40",
            "country_code": "ro"
        },
        {
            "country_name": "Russia",
            "country_dial_code": "+7",
            "country_code": "ru"
        },
        {
            "country_name": "Rwanda",
            "country_dial_code": "+250",
            "country_code": "rw"
        },
        {
            "country_name": "Saint Kitts and Nevis",
            "country_dial_code": "+1869",
            "country_code": "kn"
        },
        {
            "country_name": "Saint Lucia",
            "country_dial_code": "+1758",
            "country_code": "lc"
        },
        {
            "country_name": "Saint Vincent and the Grenadines",
            "country_dial_code": "+1784",
            "country_code": "vc"
        },
        {
            "country_name": "Samoa",
            "country_dial_code": "+685",
            "country_code": "ws"
        },
        {
            "country_name": "San Marino",
            "country_dial_code": "+378",
            "country_code": "sm"
        },
        {
            "country_name": "Sao Tome and Principe",
            "country_dial_code": "+239",
            "country_code": "st"
        },
        {
            "country_name": "Saudi Arabia",
            "country_dial_code": "+966",
            "country_code": "sa"
        },
        {
            "country_name": "Senegal",
            "country_dial_code": "+221",
            "country_code": "sn"
        },
        {
            "country_name": "Serbia",
            "country_dial_code": "+381",
            "country_code": "rs"
        },
        {
            "country_name": "Seychelles",
            "country_dial_code": "+248",
            "country_code": "sc"
        },
        {
            "country_name": "Sierra Leone",
            "country_dial_code": "+232",
            "country_code": "sl"
        },
        {
            "country_name": "Singapore",
            "country_dial_code": "+65",
            "country_code": "sg"
        },
        {
            "country_name": "Slovakia",
            "country_dial_code": "+421",
            "country_code": "sk"
        },
        {
            "country_name": "Slovenia",
            "country_dial_code": "+386",
            "country_code": "si"
        },
        {
            "country_name": "Solomon Islands",
            "country_dial_code": "+677",
            "country_code": "sb"
        },
        {
            "country_name": "Somalia",
            "country_dial_code": "+252",
            "country_code": "so"
        },
        {
            "country_name": "South Africa",
            "country_dial_code": "+27",
            "country_code": "za"
        },
        {
            "country_name": "South Korea",
            "country_dial_code": "+82",
            "country_code": "kr"
        },
        {
            "country_name": "South Sudan",
            "country_dial_code": "+211",
            "country_code": "ss"
        },
        {
            "country_name": "Spain",
            "country_dial_code": "+34",
            "country_code": "es"
        },
        {
            "country_name": "Sri Lanka",
            "country_dial_code": "+94",
            "country_code": "lk"
        },
        {
            "country_name": "Sudan",
            "country_dial_code": "+249",
            "country_code": "sd"
        },
        {
            "country_name": "Suriname",
            "country_dial_code": "+597",
            "country_code": "sr"
        },
        {
            "country_name": "Sweden",
            "country_dial_code": "+46",
            "country_code": "se"
        },
        {
            "country_name": "Switzerland",
            "country_dial_code": "+41",
            "country_code": "ch"
        },
        {
            "country_name": "Syria",
            "country_dial_code": "+963",
            "country_code": "sy"
        },
        {
            "country_name": "Taiwan",
            "country_dial_code": "+886",
            "country_code": "tw"
        },
        {
            "country_name": "Tajikistan",
            "country_dial_code": "+992",
            "country_code": "tj"
        },
        {
            "country_name": "Tanzania",
            "country_dial_code": "+255",
            "country_code": "tz"
        },
        {
            "country_name": "Thailand",
            "country_dial_code": "+66",
            "country_code": "th"
        },
        {
            "country_name": "Timor-Leste",
            "country_dial_code": "+670",
            "country_code": "tl"
        },
        {
            "country_name": "Togo",
            "country_dial_code": "+228",
            "country_code": "tg"
        },
        {
            "country_name": "Tokelau",
            "country_dial_code": "+690",
            "country_code": "tk"
        },
        {
            "country_name": "Tonga",
            "country_dial_code": "+676",
            "country_code": "to"
        },
        {
            "country_name": "Trinidad and Tobago",
            "country_dial_code": "+1868",
            "country_code": "tt"
        },
        {
            "country_name": "Tunisia",
            "country_dial_code": "+216",
            "country_code": "tn"
        },
        {
            "country_name": "Turkey",
            "country_dial_code": "+90",
            "country_code": "tr"
        },
        {
            "country_name": "Turkmenistan",
            "country_dial_code": "+993",
            "country_code": "tm"
        },
        {
            "country_name": "Turks and Caicos Islands",
            "country_dial_code": "+1649",
            "country_code": "tc"
        },
        {
            "country_name": "Tuvalu",
            "country_dial_code": "+688",
            "country_code": "tv"
        },
        {
            "country_name": "U.S. Virgin Islands",
            "country_dial_code": "+1340",
            "country_code": "vi"
        },
        {
            "country_name": "Uganda",
            "country_dial_code": "+256",
            "country_code": "ug"
        },
        {
            "country_name": "Ukraine",
            "country_dial_code": "+380",
            "country_code": "ua"
        },
        {
            "country_name": "United Arab Emirates",
            "country_dial_code": "+971",
            "country_code": "uae"
        },
        {
            "country_name": "United Kingdom",
            "country_dial_code": "+44",
            "country_code": "uk"
        },
        {
            "country_name": "Uruguay",
            "country_dial_code": "+598",
            "country_code": "uy"
        },
        {
            "country_name": "Uzbekistan",
            "country_dial_code": "+998",
            "country_code": "uz"
        },
        {
            "country_name": "Vanuatu",
            "country_dial_code": "+678",
            "country_code": "vu"
        },
        {
            "country_name": "Vatican City",
            "country_dial_code": "+39",
            "country_code": "va"
        },
        {
            "country_name": "Venezuela",
            "country_dial_code": "+58",
            "country_code": "ve"
        },
        {
            "country_name": "Vietnam",
            "country_dial_code": "+84",
            "country_code": "vn"
        },
        {
            "country_name": "Wallis and Futuna",
            "country_dial_code": "+681",
            "country_code": "wf"
        },
        {
            "country_name": "Western Sahara",
            "country_dial_code": "+212",
            "country_code": "eh"
        },
        {
            "country_name": "Yemen",
            "country_dial_code": "+967",
            "country_code": "ye"
        },
        {
            "country_name": "Zambia",
            "country_dial_code": "+260",
            "country_code": "zm"
        },
        {
            "country_name": "Zimbabwe",
            "country_dial_code": "+263",
            "country_code": "zw"
        }
    ]
}
